 
@if (loading) {
  <div class="spinner-container">
    <div class="spinner"></div>
  </div>
} @else {
  <app-summary-cards [cards]="adminCards" (cardClick)="onActiveCardFilterChange($event)" [clearFiltersEvent]="clearFiltersTrigger"></app-summary-cards>
  <app-donor-table [donors]="donors" [admins]="admins" [activeCardFilter]="selectedCardFilter" [incomingFilters]="incomingFilters"  (clearFiltersEvent)="onClearFilters()"></app-donor-table>

}
